import { Heading, Paragraph } from "@/components/ui/Typography";
import type { MicroSite } from "@/lib/api";
import { sanitizeHtml } from "@/utils/helpers/html";

const NewsFeedOverview = ({data}:{data: MicroSite}) => {
  
if(!data) {
    return null;
};   


  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full p-4 lg:p-8 gap-2  justify-center" >   
          <div className="flex items-center gap-3">
          <Heading level={3}>{data?.newsFeedSection?.newsFeedTitle}</Heading>
          </div>
          <Paragraph className="lg:w-1/2" dangerouslySetInnerHTML={{ __html: sanitizeHtml(data?.newsFeedSection?.newsFeedDescription ?? "") }}></Paragraph>
      </div>
    )
  };

  return (
    <div>
      <PreviewComponent />
    </div>
  )
}

export default NewsFeedOverview